export default __webpack_public_path__ + "static/media/logo13.8bc23aff.png";